module.exports = __webpack_public_path__ + "static/media/serieNaRealCuradoria.b3b15892.jpg";